import { render, staticRenderFns } from "./sectionTransactionLaunched.vue?vue&type=template&id=4a87e24c"
import script from "./sectionTransactionLaunched.vue?vue&type=script&lang=js"
export * from "./sectionTransactionLaunched.vue?vue&type=script&lang=js"
import style0 from "./sectionTransactionLaunched.vue?vue&type=style&index=0&id=4a87e24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports